import React from 'react';
import { Button } from '../ui/button';
import { ArrowLeft, Save, Loader2 } from 'lucide-react';

const ProjectFormHeader = ({ isEdit, loading, onBack, onSubmit }) => {
  return (
    <div className="sticky top-16 z-40 bg-background/95 backdrop-blur-sm border-b shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={onBack}
              className="flex items-center space-x-2"
            >
              <ArrowLeft className="h-4 w-4" />
              <span>กลับ</span>
            </Button>
            <div>
              <h1 className="text-2xl font-bold text-foreground">
                {isEdit ? 'แก้ไขโปรเจค' : 'เพิ่มโปรเจคใหม่'}
              </h1>
              <p className="text-sm text-muted-foreground">
                {isEdit ? 'แก้ไขข้อมูลโปรเจค' : 'สร้างโปรเจคใหม่และจัดการการเงิน'}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <Button
              variant="outline"
              onClick={onBack}
            >
              ยกเลิก
            </Button>
            <Button
              onClick={onSubmit}
              disabled={loading}
              className="flex items-center space-x-2"
            >
              {loading ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <Save className="h-4 w-4" />
              )}
              <span>บันทึก</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectFormHeader;
